<template>
  <v-card>
    <project-flow-navigation-toolbar
      :title="projectName"
    ></project-flow-navigation-toolbar>
    <v-toolbar dense>
      <v-tabs v-model="tab" @change="onTabChange">
        <v-tab href="#details"> Details </v-tab>
        <v-tab href="#media"> Media </v-tab>
        <v-tab href="#masterplans"> Masterplans </v-tab>
        <v-tab href="#users" v-if="allowedUsersOnProject"> Users </v-tab>
        <!-- <v-tab href="#reservations">
          Reservations
        </v-tab> -->
        <v-tab href="#mediaManager"> Media manager </v-tab>
        <v-tab href="#projectSettings"> Settings </v-tab>
        <v-tab href="#packageList"> Packages </v-tab>
        <v-tab href="#buildingSettings"> Building settings </v-tab>
        <v-tab href="#apartmentSettings"> Apartment settings </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="currentTab">
      <v-tab-item value="details">
        <v-card>
          <v-card-text>
            <v-container class="pa-0">
              <v-row>
                <v-col>
                  <v-card elevation="6">
                    <v-card-title>Project name</v-card-title>
                    <v-card-text>
                      <v-text-field
                        hide-details="auto"
                        class="mt-0 pt-0"
                        v-model="project.name"
                      ></v-text-field>
                    </v-card-text>
                  </v-card>
                  <v-card class="mt-4" elevation="6">
                    <v-card-title>
                      {{
                        `Project is: ${
                          project.publish ? 'published' : 'unpublished'
                        }`
                      }}
                    </v-card-title>
                    <v-card-text>
                      <v-switch
                        inset
                        hide-details="auto"
                        class="mt-0 ml-1"
                        v-model="project.publish"
                      >
                      </v-switch>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="isSuperAdmin">
                  <v-card elevation="6">
                    <v-card-title>Properties</v-card-title>
                    <v-card-text>
                      <v-jsoneditor
                        v-model="project.properties"
                        :plus="true"
                        height="156px"
                        @onChangeText="onJsonEditorChange"
                        :options="{ mode: 'text' }"
                      ></v-jsoneditor>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-card elevation="6 mt-4">
                <v-card-title>
                  Geo Location
                  <v-spacer />
                </v-card-title>
                <v-card-text style="height: 315px">
                  <MglMap
                    ref="map"
                    v-if="project.id"
                    :accessToken="accessToken"
                    :mapStyle="mapStyle"
                    @load="setCenter($event, project)"
                    :zoom="project.geocode ? 14 : 9"
                    @click="SetGeoCode($event)"
                  >
                    <MglGeocoderControl :accessToken="accessToken" :limit="5" />
                    <MglMarker
                      v-if="project.geocode"
                      :coordinates="GetGeoCodeArray(project.geocode)"
                      color="gray"
                    />
                  </MglMap>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card-text>
          <v-card-actions class="d-flex pa-4 pt-0">
            <v-btn
              v-if="showDeleteProjectButton"
              color="red darken-1"
              @click="deleteProject"
              >Delete</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="darken-1"
              :disabled="saveButtonDisabled"
              @click="cancel"
              >Cancel</v-btn
            >
            <v-btn
              color="primary darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item value="media">
        <media
          :media="this.$store.state.MediaStore.media"
          :is-visible="currentTab === 'media'"
        ></media>
      </v-tab-item>
      <v-tab-item value="masterplans" class="ma-4">
        <masterplan-list
          :masterplanList="this.$store.state.MasterplanStore.masterplans"
        ></masterplan-list>
      </v-tab-item>
      <v-tab-item value="users" v-if="allowedUsersOnProject" class="ma-4">
        <user-list
          :userList="this.$store.state.ProjectStore.usersOnProject"
        ></user-list>
      </v-tab-item>
      <!-- <v-tab-item value="reservations">
        <v-list-item>
          <v-list-item-content>
            <reservations-list
              :reservationsList="
                this.$store.state.ProjectStore.selectedProjectReservations
              "
            ></reservations-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item> -->
      <v-tab-item value="mediaManager">
        <media-manager
          :media="this.$store.state.MediaManagerStore.media"
          :is-visible="currentTab === 'mediaManager'"
        ></media-manager>
      </v-tab-item>
      <v-tab-item value="projectSettings">
        <project-settings
          :currentTab="currentTab"
          @changeDetectedSettings="setChangeDetectedSettings($event)"
        ></project-settings>
      </v-tab-item>
      <v-tab-item value="packageList" class="ma-4">
        <package-list
          :packageList="this.$store.state.ProjectPackagesStore.packages"
        ></package-list>
      </v-tab-item>
      <v-tab-item
        value="buildingSettings"
        class="ma-4"
        v-if="allowedUsersOnProject"
      >
        <building-settings
          :projectBuildings="this.$store.state.BuildingStore.projectBuildings"
        ></building-settings>
      </v-tab-item>
      <v-tab-item
        value="apartmentSettings"
        class="ma-4"
        v-if="allowedUsersOnProject"
      >
        <apartment-settings
          :projectApartments="
            this.$store.state.ApartmentStore.projectApartments
          "
        ></apartment-settings>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
//import SimpleTextMediaItemCard from "../components/SimpleTextMediaItemCard"
import MasterplanList from '../../components/RecordLists/MasterplanList'
import ReservationsList from '../../components/RecordLists/ReservationsList'
import PackageList from '../../components/RecordLists/PackageList'
import UserList from '../../components/RecordLists/UserList'
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Media from '../../views/Media'
import MediaManager from '../../views/MediaManager'
import ProjectSettings from '../../views/ProjectSettings'
import { UserRolesMixin } from '@/mixins/UserRolesMixin'
import VJsoneditor from 'v-jsoneditor/src/index'
import Mapbox from 'mapbox-gl'
import { EventBus } from '../../helpers/Events'
import MediaService from '@/services/MediaService'
import ProjectsService from '@/services/ProjectsService'
import {
  MglMap,
  MglMarker,
  MglNavigationControl,
  MglGeolocateControl
} from 'vue-mapbox'
import MglGeocoderControl from 'vue-mapbox-geocoder'
import BuildingSettings from '../BuildingSettings'
import ApartmentSettings from '../ApartmentSettings'

export default {
  mixins: [UserRolesMixin],
  name: 'ProjectExpore',
  props: {},
  components: {
    MasterplanList,
    PackageList,
    ProjectFlowNavigationToolbar,
    Media,
    MediaManager,
    ProjectSettings,
    UserList,
    VJsoneditor,
    MglMap,
    MglMarker,
    MglGeocoderControl,
    BuildingSettings,
    ApartmentSettings
  },
  data: function() {
    return {
      changeDetectedSettings: false,
      projectHeaderImageUrl: '',
      mediaItemComponents: [],
      projectMasterplans: [],
      projectPackages: [],
      tab: 'details',
      currentTab: 'details',
      project: {},
      changeDetected: false,
      allowedUsersOnProject: false,
      showDeleteProjectButton: false,
      accessToken:
        'pk.eyJ1IjoiYmFuZXpha2xhbiIsImEiOiJja2lrYXBlZnIwN3p5MnJvZGRtY2V4OTlsIn0.4kEMskeVR3EcJiM8o5qdxA',
      mapStyle: 'mapbox://styles/banezaklan/ckij1dyhk18f11an6zjbxul9w'
    }
  },
  methods: {
    setChangeDetectedSettings(e) {
      this.changeDetectedSettings = e
    },
    onTabChange() {
      if (this.changeDetectedSettings) {
        this.$store.dispatch('DialogStore/open', {
          title: 'You made changes which have not been saved.',
          okText: 'Cancel',
          ok: () => {
            this.tab = this.currentTab
          },
          saveText: 'Save',
          save: () => {
            EventBus.$emit('saveSettings')
            this.currentTab = this.tab
          },
          cancelText: 'Discard',
          cancel: () => {
            this.cancel()
            this.currentTab = this.tab
          }
        })
      } else if (this.changeDetected) {
        this.$store.dispatch('DialogStore/open', {
          title: 'You made changes which have not been saved.',
          okText: 'Cancel',
          ok: () => {
            this.tab = this.currentTab
          },
          cancelText: 'Discard',
          cancel: () => {
            this.cancel()
            this.currentTab = this.tab
          }
        })
      } else {
        this.currentTab = this.tab
      }
    },
    GetGeoCodeArray(geocode) {
      let parsedGeoCode = geocode
      if (typeof geocode === 'string') {
        parsedGeoCode = JSON.parse(geocode)
      }
      let arr = []
      arr.push(parsedGeoCode.lng)
      arr.push(parsedGeoCode.lat)
      return arr
    },
    setCenter(e, project) {
      let parsedGeoCode = [20.461, 44.812]
      if (project.geocode) {
        parsedGeoCode = project.geocode
        if (typeof project.geocode === 'string') {
          parsedGeoCode = JSON.parse(project.geocode)
        }
      }
      e.map.flyTo({ center: parsedGeoCode, maxDuration: 1000 })
    },
    SetGeoCode(e) {
      if (e.mapboxEvent.lngLat) {
        this.project.geocode = e.mapboxEvent.lngLat
      }
    },
    deleteMediaById: async function(poiId) {
      return await MediaService.deleteMediaById(poiId)
    },
    setupFields: function() {
      let p = this.$store.state.ProjectStore.selectedProject
      this.mediaItemComponents = []
      this.mediaItemComponents.push({
        id: 'project-' + p.id,
        label: 'Project Name',
        type: 'BaseSimpleTextCard',
        value: this.$store.state.ProjectStore.selectedProject.name,
        isTextArea: false,
        handleSaveEvent: async newValue => {
          await this.$store.dispatch('ProjectStore/updateProject', {
            id: p.id,
            name: newValue
          })
        }
      })

      for (
        var i = 0,
          len = this.$store.state.ProjectStore.selectedProject.Media.length;
        i < len;
        i++
      ) {
        let m = this.$store.state.ProjectStore.selectedProject.Media[i]
        if (m.mediaTypeId === 3) {
          this.projectHeaderImageUrl =
            m.url + '?random=' + Math.floor(Math.random() * 10 + 1)
        } else if (m.mediaTypeId === 4) {
          this.mediaItemComponents.push({
            id: 'media-' + m.id,
            label: 'Project Description',
            type: 'BaseSimpleTextCard',
            value: m.textualContent,
            isTextArea: true,
            handleSaveEvent: newValue => {
              this.$store.dispatch('ProjectStore/updateProjectMediaItem', {
                id: m.id,
                textualContent: newValue
              })
            }
          })
        }
      }
    },

    getData: async function(projectId) {
      if (projectId) {
        await this.$store.dispatch('BreadcrumbsStore/clear')
        await this.$store.dispatch('MediaStore/resetStore')
        await this.$store.dispatch(
          'ProjectStore/setSelectedProject',
          projectId,
          {
            root: true
          }
        )

        this.project = JSON.parse(
          JSON.stringify(this.$store.state.ProjectStore.selectedProject)
        )

        await this.$store.dispatch(
          'ClientAppStore/fetchClientAppsForProject',
          projectId
        )

        if (
          this.$store.state.ClientAppStore.apps[0] &&
          this.$store.state.ClientAppStore.apps[0].id
        ) {
          await this.$store.dispatch(
            'ClientAppStore/selectClientApp',
            this.$store.state.ClientAppStore.apps[0].id
          )
        }

        await this.$store.dispatch('MasterplanStore/fetchMasterplans', {
          root: true
        })
        await this.$store.dispatch('BuildingStore/fetchProjectBuildings', {
          root: true
        })
        await this.$store.dispatch('ApartmentStore/fetchProjectApartments', {
          root: true
        })

        await this.$store.dispatch(
          'ProjectStore/setSelectedProjectReservations',
          projectId
        )
        await this.$store.dispatch('MediaStore/setMediaContext', 'project')
        // await this.$store.dispatch('MediaStore/fetchMediaTypes', 'project')
        // await this.$store.dispatch('MediaStore/fetchMedia')
        //Project packages
        await this.$store.dispatch('ProjectPackagesStore/fetchPackages', {
          root: true
        })
        // users on project

        this.allowedUsersOnProject = await this.isAllowedOnResource(
          'users-on-project',
          'show',
          projectId
        )

        if (this.allowedUsersOnProject) {
          await this.$store.dispatch(
            'ProjectStore/getUsersOnProject',
            projectId
          )
          await this.$store.dispatch('UserStore/getUserRoles')
          await this.$store.dispatch('UserStore/getAllUserRoles')

          ProjectsService.getUsersOnProject(
            this.$store.state.ProjectStore.selectedProject.id
          ).then(r => {
            let users = r.data
            let currentUser = this.$store.state.UserStore.user
            let userOnProject = users.filter(el => el.id === currentUser.id)
            if (
              userOnProject[0].roleOnProject === 'project_admin' ||
              this.$store.state.UserStore.userRole[0] === 'super_admin'
            ) {
              this.showDeleteProjectButton = true
            }
          })
        }
      }
    },

    save: async function() {
      if (this.project.geocode && typeof this.project.geocode === 'string') {
        this.project.geocode = JSON.parse(this.project.geocode)
      }
      await this.$store.dispatch('ProjectStore/updateProject', this.project)
      // Upisivanje updateovanog projekta se sada izvrsava u updateProject akciji:
      // await this.$store.dispatch(
      //   'ProjectStore/setSelectedProject',
      //   this.$route.params.projectId
      // )
      this.project = JSON.parse(
        JSON.stringify(this.$store.state.ProjectStore.selectedProject)
      )
      this.changeDetected = false
    },

    cancel: async function() {
      await this.$store.dispatch(
        'ProjectStore/setSelectedProject',
        this.$route.params.projectId
      )
      this.project = JSON.parse(
        JSON.stringify(this.$store.state.ProjectStore.selectedProject)
      )
      this.changeDetected = false
    },
    removeUserFromProject: async function(userId, projectId) {
      let data = {
        userId: userId,
        projectId: projectId
      }
      await this.$store.dispatch('UserStore/removeUserFromProject', data)
    },
    removeAdminFromProject: async function(projectId) {
      const superAdminRole = 1
      this.removeUserFromProject(superAdminRole, projectId)
    },
    deleteProject: async function() {
      const selectedProject = this.$store.state.ProjectStore.selectedProject
      this.$confirm({
        title: 'Delete Project',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch(
              'ProjectStore/deleteProject',
              this.$route.params.projectId
            )
            .then(
              () => {
                this.removeAdminFromProject(selectedProject.id)
                const usersOnProject = this.$store.state.ProjectStore
                  .usersOnProject
                for (var i = 0; i < usersOnProject.length; i++) {
                  this.removeUserFromProject(
                    usersOnProject[i].id,
                    selectedProject.id
                  )
                }
                this.$store.dispatch('UserStore/getUserRoles')
                this.deleteMediaById(
                  this.$store.state.ProjectStore.projectConfig[0].id
                ).then(() => {
                  this.$router.push('/')
                  this.$emit('deleted')
                })
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message: 'Project has child records, it cannot be deleted.'
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {})
    },
    onJsonEditorChange(newJson) {
      //this.editedItem.mediaData = newJson
    }
  },
  created: async function() {
    let lastBreadcrumb = this.$store.state.BreadcrumbsStore.history[
      this.$store.state.BreadcrumbsStore.history.length - 2
    ]
    if (lastBreadcrumb && lastBreadcrumb.tab) {
      if (lastBreadcrumb.tab === 'MASTERPLAN ') {
        this.tab = 'masterplans'
        this.currentTab = 'masterplans'
      } else if (lastBreadcrumb.tab === 'MEDIA MANAGER ') {
        this.tab = 'mediaManager'
        this.currentTab = 'mediaManager'
      } else if (lastBreadcrumb.tab === 'packageList') {
        this.tab = 'pakageList'
        this.currentTab = 'packageList'
      } else if (lastBreadcrumb.tab === 'buildingSettings') {
        this.tab = 'buildingSettings'
        this.currentTab = 'buildingSettings'
      } else if (lastBreadcrumb.tab === 'apartmentSettings') {
        this.tab = 'apartmentSettings'
        this.currentTab = 'apartmentSettings'
      } else if (lastBreadcrumb.tab === 'pois') {
        this.tab = 'pois'
        this.currentTab = 'pois'
      } else {
        this.tab = 'details'
        this.currentTab = 'details'
      }
    }
    // if (localStorage.getItem('exploreProjectActiveTab')) {
    //   this.tab = localStorage.exploreProjectActiveTab
    // }
    this.mapbox = Mapbox
    await this.$store.dispatch(
      'ProjectStore/getSelectedProjectSettings',
      this.$route.params.projectId
    )
  },
  computed: {
    projectName: function() {
      return this.$store.state.ProjectStore.selectedProject
        ? this.$store.state.ProjectStore.selectedProject.name
        : ''
    },
    isSuperAdmin() {
      return this.$store.state.UserStore.userRole[0] === 'super_admin'
    },
    getSelectedProject() {
      return this.$store.state.ProjectStore.selectedProject
    },
    saveButtonDisabled: function() {
      return !this.changeDetected
    },
    items() {
      return this.entries.map(entry => {
        const Description =
          entry.place_name.length > this.descriptionLimit
            ? entry.place_name.slice(0, this.descriptionLimit) + '...'
            : entry.place_name

        return Object.assign({}, entry, { Description })
      })
    }
  },
  watch: {
    '$store.state.MediaStore.media'() {},
    project: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (
          JSON.stringify(before) !== '{}' &&
          JSON.stringify(this.project) !==
            JSON.stringify(this.$store.state.ProjectStore.selectedProject)
        ) {
          this.changeDetected = true
        }
      }
    },
    '$store.state.ProjectStore.selectedProject': async function() {
      await this.$store.dispatch('BreadcrumbsStore/clear')
      await this.$store.dispatch('BreadcrumbsStore/add', {
        text: 'PROJECT ',
        name: this.projectName
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    localStorage.removeItem('exploreProjectActiveTab')
    localStorage.removeItem('exploreMasterplanActiveTabs')
    localStorage.removeItem('exploreBuildingActiveTabs')
    localStorage.removeItem('exploreApartmentActiveTabs')
    next(vm => {
      vm.getData(parseInt(to.params.projectId))
    })
  },
  async beforeRouteUpdate(to, from, next) {
    this.getData(to.params.projectId)
    next()
  },
  beforeRouteLeave(to, from, next) {
    if (this.changeDetectedSettings) {
      this.$store.dispatch('DialogStore/open', {
        title: 'You made changes which have not been saved.',
        okText: 'Cancel',
        ok: () => {
          next(false)
        },
        saveText: 'Save',
        save: () => {
          EventBus.$emit('saveSettings')
          setTimeout(() => {
            next()
          }, 300)
        },
        cancelText: 'Discard',
        cancel: () => {
          localStorage.exploreProjectActiveTab = 'details'
          next()
        }
      })
    } else if (this.changeDetected) {
      this.$store.dispatch('DialogStore/open', {
        title: 'You made changes which have not been saved.',
        okText: 'Cancel',
        ok: () => {
          next(false)
        },
        cancelText: 'Discard',
        cancel: () => {
          localStorage.exploreProjectActiveTab = 'details'
          next()
        }
      })
    } else {
      if (to.name == 'Explore Masterplan') {
        localStorage.exploreProjectActiveTab = this.tab
        next()
      } else {
        localStorage.exploreProjectActiveTab = 'details'
        next()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 4em;
  z-index: 2;
}
.mapboxgl-ctrl.mapboxgl-ctrl-attrib {
  background: transparent !important;
}
.jsoneditor-text {
  min-height: 0px !important;
}
</style>
